import { useCallback, useEffect, useRef } from 'react'
import { QrCode01Icon } from '@hugeicons/core-solid-rounded'
import { Plural, useLingui } from '@lingui/react/macro'

import Button from '@/components/ui/Button'
import Field from '@/components/ui/Field'
import { QrCodeContent, Styling, useQrCodes } from '../hooks/useQrCode'

export function QrCodeGenerator({
  contents,
  styling
}: {
  contents: QrCodeContent[]
  styling: Styling
}) {
  const { t } = useLingui()
  const qrCodes = useQrCodes(contents, styling)
  const previewRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!previewRef.current) return

    Array.from(previewRef.current.children).forEach(child => child.remove())

    qrCodes[0].append(previewRef.current)
  }, [qrCodes])

  const onDownload = useCallback(() => {
    qrCodes.forEach(function (qrCode, index) {
      const { text } = contents[index]

      qrCode?.download({ extension: 'png', name: `QrCode_${text}` })
    })
  }, [qrCodes, contents])

  return (
    <div className="relative flex flex-col gap-2 items-center">
      <Field label={t`Example`}>
        <div ref={previewRef} className="*:size-full size-72 max-w-full"></div>
      </Field>
      <Button Icon={QrCode01Icon} onClick={onDownload}>
        <Plural
          value={qrCodes.length}
          one="Download QR Code"
          other="Download QR Codes"
        />
      </Button>
      <div className="flex flex-col gap-1 p-2">
        {contents.map(content => {
          return (
            <a
              key={content.url}
              href={content.url}
              className="text-info-500 text-regular underline"
              target="_blank"
              rel="noreferrer"
            >
              {content.text ? `${content.text}: ` : ''}
              {content.url}
            </a>
          )
        })}
      </div>
    </div>
  )
}
